export default __webpack_public_path__ + "static/media/account-info-edit-icon.c399c2e0.svg";